<!--
 * @created on 2019/2/26
 * @author LaiXinYu <laixinyualex@gmail.com>
-->

<template>
    <pre :class="classArray"><template v-for="(textItem,index) in textArray"><span
        class="test-display-text"
        v-if="textItem.type === 'text'" :key="textItem.text+index">{{ textItem.text }}</span><a
        :href="textItem.text" class="text-link"
        v-else-if="textItem.type === 'link'" :key="textItem.text+index">{{ textItem.text}}</a></template></pre>
</template>

<style scoped lang="scss">
pre {
    font-family: inherit;
    white-space: pre-wrap;
    word-wrap: break-word;
}

.text-link {
    text-decoration: underline;
    color: #3d7e9a;

    &:visited {
        color: #3d7e9a;
    }
}
</style>

<script>
export default {
    name: "TextDisplay",
    props: {
        content: {
            type: String,
            default: null
        },
        className: {
            type: String,
            default: ""
        }
    },

    created() {
        this.textArray = this.textHandle();
    },

    data() {
        return {
            textArray: []
        };
    },

    computed: {
        text() {
            return decodeURIComponent(this.content);
        },
        classArray() {
            return ["text-display", ...this.className.split(" ")];
        }
    },
    methods: {
        textHandle() {
            let textArray = this.text.split(/(\$\$.*?\$\$)/);

            let result = [];

            textArray.forEach(item => {
                let resultItem = {};

                if (
                    /\$\$.*\$\$/.test(item) &&
                    /chuxingyouhui\.com/.test(item)
                ) {
                    resultItem = {
                        text: item.replace(/\$\$/g, ""),
                        type: "link"
                    };
                } else {
                    resultItem = {
                        text: item,
                        type: "text"
                    };
                }

                result.push(resultItem);
            });

            return result;
        }
    }
};
</script>
